export const sbemShadCNTheme = {
    light : {
        background: '#F6F6F7',
        foreground: '#333333',
        'navbar-background': '#FFFFFF',
        'navbar-foreground': '#333333',
        card: '#FFFFFF',
        'card-foreground': '#404247',
        popover: '#FFFFFF',
        'popover-foreground': '#404247',
        primary: '#309AB5',
        'primary-foreground': '#FFFFFF',
        secondary: '#FFFFFF',
        'secondary-foreground': '#121315',
        accent: '#BCEAF8',
        'accent-foreground': '#404247',
        muted: '#E1E2E5',
        'muted-foreground': '#54575D',
        'primary-button': '#404247',
        'primary-button-foreground': '#FFFFFF',
        destructive: '#DC2626',
        'destructive-foreground': '#FEF2F2',
        info: '#0891B2',
        'info-foreground': '#ECFEFF',
        success: '#15803D',
        'success-foreground': '#DCFCE7',
        warning: '#A16207',
        'warning-foreground': '#FEF9C3',
        border: '#E5E5E5',
        input: '#E5E5E5',
        ring: '#007B94',
        sidebar: '#FFFFFF',
        'sidebar-foreground': '#404247',
        'font-titles': 'Roboto, ui-sans-serif, sans-serif, system-ui',
        'font-body': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
        radius: '1rem',
        spacing: '0.25rem',
        'shadow-color': 'hsl(0 0% 0%)',
        'shadow-offset-x': '0px',
        'shadow-offset-y': '1px',
        'shadow-blur-radius': '3px',
        'shadow-spread': '0px',
        'shadow-opacity': '0.1',
        'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
        'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
        'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
        'shadow': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
        'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
        'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
        'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
        'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)'
    },
    dark : {},
    fontsUsage: {}
};


// WEBPACK FOOTER //
// ./src/constants/themes/sbemShadCNTheme.js